// extracted by mini-css-extract-plugin
export default {"sideNavbar":"SideNavbar_sideNavbar__SwZNG","right":"SideNavbar_right__9lHp4","left":"SideNavbar_left__VqjI1"};